import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OnboardingMenu, UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
@UntilDestroy()

@Component({
  selector: 'app-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.css']
})
export class WrapperComponent implements OnInit {
  companyId: any;
  userPermission = UserPermission;
  selectedMenu: any = OnboardingMenu.DASHBOARD;
  onboardingMenu = OnboardingMenu;
  company: any;

  constructor(
    public permissionService: PermissionService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.setupFragment();
    this.route.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.companyId = params["companyId"];
        if (this.companyId) {
          this.getCompanybyId();
        }
      });
  }

  setupFragment() {
    const fragment = this.route.snapshot.fragment;
    if (fragment) {
      this.onSelectMenu(fragment);
    } else {
      this.setFirstPermittedMenu();
      this.router.navigate([], {
        relativeTo: this.route,
        fragment: this.selectedMenu
      });
    }
    setTimeout(() => {
      this.route.fragment.subscribe(fragment => {
        if (!fragment) {
          this.onSelectMenu(OnboardingMenu.DASHBOARD);
        } else {
          if (this.selectedMenu !== fragment) {
            this.onSelectMenu(fragment);
          }
        }
      });
    }, 1000);
  }

  getCompanybyId() {
    this.companyService
      .getCompanyById(this.companyId)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.company = data;
        }
      });
  }

  onSelectMenu(menu: any) {
    this.selectedMenu = menu;
    this.router.navigate([], {
      relativeTo: this.route,
      fragment: menu
    });
  }

  setFirstPermittedMenu() {
    if (this.isMenuAllowed(OnboardingMenu.DASHBOARD)) {
      this.selectedMenu = OnboardingMenu.DASHBOARD;
    } else if (this.isMenuAllowed(OnboardingMenu.CONFIGURATION)) {
      this.selectedMenu = OnboardingMenu.CONFIGURATION;
    } else if (this.isMenuAllowed(OnboardingMenu.COMPANY)) {
      this.selectedMenu = OnboardingMenu.COMPANY;
    } else if (this.isMenuAllowed(OnboardingMenu.DRIVERS)) {
      this.selectedMenu = OnboardingMenu.DRIVERS;
    } else if (this.isMenuAllowed(OnboardingMenu.VEHICLES)) {
      this.selectedMenu = OnboardingMenu.VEHICLES;
    } else if (this.isMenuAllowed(OnboardingMenu.RATES)) {
      this.selectedMenu = OnboardingMenu.RATES;
    } else if (this.isMenuAllowed(OnboardingMenu.THRESHOLD)) {
      this.selectedMenu = OnboardingMenu.THRESHOLD;
    } else if (this.isMenuAllowed(OnboardingMenu.ATTACHMENTS)) {
      this.selectedMenu = OnboardingMenu.ATTACHMENTS;
    }
  }

  isMenuAllowed(menu: any) {
    switch (menu) {
      case OnboardingMenu.DASHBOARD:
        return this.permissionService.hasPermission([
          this.userPermission.GET_COMPANY,
          this.userPermission.GET_THRESHOLD_DASHBOARD
        ]);
      case OnboardingMenu.CONFIGURATION:
        return this.permissionService.hasPermission([
          this.userPermission.GET_COMPANY_CONFIGURATION,
          this.userPermission.MANAGE_COMPANY_CONFIGURATION
        ]);
      case OnboardingMenu.COMPANY:
        return this.permissionService.hasPermission([
          this.userPermission.GET_COMPANY,
          this.userPermission.MANAGE_COMPANY
        ]);
      case OnboardingMenu.DRIVERS:
        return this.permissionService.hasPermission([
          this.userPermission.GET_DRIVER
        ]);
      case OnboardingMenu.VEHICLES:
        return this.permissionService.hasPermission([
          this.userPermission.GET_VEHICLE
        ]);
      case OnboardingMenu.RATES:
        return this.permissionService.hasPermission([
          this.userPermission.GET_FARES
        ]);
      case OnboardingMenu.THRESHOLD:
        return this.permissionService.hasPermission([
          this.userPermission.GET_THRESHOLD
        ]);
      case OnboardingMenu.ATTACHMENTS:
        return this.permissionService.hasPermission([
          this.userPermission.GET_COMPANY
        ]);
      default:
        return false;

    }
  }
}
